export default __webpack_public_path__ + "static/media/18.98f0423a.jpg";